// 철강협회(ksteel) 결과보고서 표지·파일명의 연도.
// 소비처: report.naming.mixin.js, ReportBulkGenerator.vue
//
// 철강협회 프로젝트 코드는 연도 접미사를 단다 (POSCO_25, SEAH_CSS_26 …). 같은 ksteel 렌더러로
// 2025·2026 캠페인을 모두 그리므로 연도는 렌더러가 아니라 프로젝트 코드로 정한다.
// 접미사가 없으면 종전 하드코딩 값(2025)을 유지한다.
const DEFAULT_YEAR = '2025';

function ksteelReportYear (project_code) {
    const m = typeof project_code === 'string' && project_code.match(/_(\d{2})$/);
    return m ? `20${m[1]}` : DEFAULT_YEAR;
}

module.exports = { ksteelReportYear };
